<kgrid
  [apiName]="apiName"
  [label]="label"
  [name]="apiName"
  [areaName]="areaName"
  pathPreFix="HRM"
  reportName="NationalityKindList"
  [inputEditorform]="inputEditorform">
</kgrid>
